import React, { useEffect, useState } from 'react';
import './index.less';
import TemplatePreviewChart from '../template-preview-chart';
import { IAgriAlertTranslateResModel, IGetHistoricalOrForecastDataResModel } from '@/util/Request/agrialert/responseType';
import { IHistoricalChartsModel } from '@/util/Request/agrialert/requestType';
import { getWeekTranslate } from '../../initData';
import { agriAlertGetHistoricalData } from '@/util/Request/agrialert';
import { AgregationEnum, HistoricalOrForecastEnum } from '@/page/Agrialert/template-management/template-management';
import moment from 'moment';

interface IProp{
    showHistoricalChart: boolean;
    translateValue: IAgriAlertTranslateResModel;
    historicalData?: IGetHistoricalOrForecastDataResModel[];
    selectedHistoricalCharts?: IHistoricalChartsModel[];
    // lant, lng and unit,lanauage
    lat: number;
    lng: number;
    unit?: string;
    language?: string;
}

const TemplateHistoricalChart = (prop:IProp)=>{

    const {
        showHistoricalChart,
        translateValue,
        historicalData,
        selectedHistoricalCharts,
        lat,
        lng,
        language,
        unit
    } = prop;

    const [finalHistoricalChartsData,setFinalHistoricalChartsData] = useState<IGetHistoricalOrForecastDataResModel[][]>([]);

    const getHistoricalChartsDataFunc = async( )=>{
        try {
            const promises = selectedHistoricalCharts?.map(async (item) => {
                return getHistoricalDataFunc(item);
            });
            // 使用 Promise.all 等待所有的 promise 完成
            const results = await Promise.all(promises);

            setFinalHistoricalChartsData(results);
            console.log('final all historical data',results);
            return results; // 返回所有结果
        } catch (error) {
            console.error('Failed to get disease risk data, error is: ', error);
            return null;
        }
    };

    const getTranslateMonthByMonthIndex = (index: number) => {
        switch (index) {
            case 0:
                return translateValue?.jan_short || 'Jan';
            case 1:
                return translateValue?.feb_short || 'Feb';
            case 2:
                return translateValue?.mar_short || 'Mar';
            case 3:
                return translateValue?.apr_short || 'Apr';
            case 4:
                return translateValue?.may_short || 'May';
            case 5:
                return translateValue?.jun_short || 'Jun';
            case 6:
                return translateValue?.jul_short || 'Jul';
            case 7:
                return translateValue?.aug_short || 'Aug';
            case 8:
                return translateValue?.sep_short || 'Sep';
            case 9:
                return translateValue?.oct_short || 'Oct';
            case 10:
                return translateValue?.nov_short || 'Nov';
            case 11:
                return translateValue?.dec_short || 'Dec';
            default:
                return '';
        }
    };

    // get historical data
    const getHistoricalDataFunc = async(requestModel: IHistoricalChartsModel)=>{
        try{
            const res = await agriAlertGetHistoricalData({
                requestVariables: requestModel?.historicalVariables,
                // requestVariables: 'precipitation;soil_temperature;temperature_daily_min;relative_humidity;temperature_daily_average;wind_speed;soil_moilsture;wind_gust;temperature_daily_max',
                lat: lat,
                lng: lng,
                startDate: null,
                aggration: requestModel?.historicalAggregation,
                requestDays: requestModel?.historicalDays,
                languageCode: language,
                unit: unit || 'metric'
            });
            const tmpData = res.data;
            tmpData.forEach((item,index)=>{
                // change date for month
                if(requestModel?.historicalAggregation === 'monthly'){
                    item?.originDate?.forEach((innerItem,innerIndex)=>{
                        const twoDigitYear = innerItem.slice(2, 4);
                        const monthIndex = moment(innerItem).month();
                        const monthName = getTranslateMonthByMonthIndex(monthIndex);
                        tmpData[index].date[innerIndex] = `${monthName} ${twoDigitYear}`;
                    });
                }
                // change week name
                item?.weeks?.forEach((innerItem,innerIndex)=>{
                    innerItem.weekName = getWeekTranslate(translateValue,innerItem?.weekIndex);
                });
                if(item.unit === 'C'){
                    item.unit = '°C';
                }
                // change series name
                if(item.variable === 'Temperature' && item.aggregation === 'min'){
                    // item.variable = 'Temperature Min';
                    item.variable = translateValue?.temperature_daily_min;
                }
                if(item.variable === 'Temperature' && item.aggregation === 'max'){
                    // item.variable = 'Temperature Max';
                    item.variable = translateValue?.temperature_daily_max;
                }
                if(item.variable === 'Temperature' && item.aggregation === 'mean'){
                    // item.variable = 'Temperature Average';
                    item.variable = translateValue?.temperature_daily_average;
                }
                if(item.code === 61){
                    item.variable = translateValue?.precipitation;
                }
                if(item.code === 52){
                    item.variable = translateValue?.relative_humidity;
                }
                if(item.code === 32){
                    item.variable = translateValue?.wind_speed;
                }
                if(item.code === 85){
                    item.variable = translateValue?.soil_temperature;
                }
                if(item.code === 144){
                    item.variable = translateValue?.soil_moilsture;
                }
                if(item.code === 180){
                    item.variable = translateValue?.wind_gust;
                }
                // new variables for forecast and historical
                if(item.code === 71){
                    item.variable = translateValue?.cloud_cover;
                }
                if(item.code === 31){
                    item.variable = translateValue?.wind_direction;
                }
                if(item.code === 204){
                    item.variable = translateValue?.radiation;
                }
                if(item.code === 17){
                    item.variable = translateValue?.dewpoint;
                }
                if(item.code === 1){
                    item.variable = translateValue?.air_pressure;
                }
                if(item.code === 730){
                    item.variable = translateValue?.growing_degree_days;
                }
                if(item.code === 2){
                    item.variable = translateValue?.precipitation_risk;
                }
                if(item.code === 3){
                    item.variable = translateValue?.shower_risk;
                }
                if(item.code === 4){
                    item.variable = translateValue?.thunderstorm_risk;
                }
            });
            // setHistoricalData(tmpData);
            return tmpData;
            console.log('historical data: ',res.data);
        }
        catch(error){
            console.log('get historical data failed, error is ',error);
        }
    };

    useEffect(()=>{
        if(showHistoricalChart && translateValue && selectedHistoricalCharts?.length >= 1){
            getHistoricalChartsDataFunc();
        }
    },[showHistoricalChart,translateValue]);
    console.log('final all historical data finalHistoricalChartsData',finalHistoricalChartsData);

    return(
        showHistoricalChart ?
            <div style={{overflow:'auto'}} className="historical-chart content-basic chart-or-table-top">
                <div className="historical-chart-title common-title">{translateValue?.historical_chart || 'Historical- Chart'}</div>
                {
                    finalHistoricalChartsData?.map((item,index)=>{
                        return(
                            <>
                                <TemplatePreviewChart
                                    id = "historicalChartRef"
                                    // echartData={historicalData}
                                    echartData={item}
                                    translateData={translateValue}
                                    chartsType={AgregationEnum.DAILY}
                                    containerHeight={490}
                                    historicalOrForecastType={HistoricalOrForecastEnum.HISTORICAL}
                                />
                            </>
                        );
                    })
                }
            </div>
            :
            null
    );
};

export default TemplateHistoricalChart;

